export default __webpack_public_path__ + "static/media/megaphone_blue.bf364f58.svg";